export default __webpack_public_path__ + "static/media/remove.332ea9eb.svg";